module.exports = __webpack_public_path__ + "img/gluten.e8577858.svg";